import { render, staticRenderFns } from "./sortear.vue?vue&type=template&id=64331ecf&"
import script from "./sortear.vue?vue&type=script&lang=js&"
export * from "./sortear.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports